import { GraviButton } from '@gravitate-js/excalibrr'
import { Button } from 'antd'
import React from 'react'

export const TimeSpanFilter = ({ onClick, onClear, buttons, selectedOptions }) => {
  return (
    <div className='order-grid-filter time-span'>
      {buttons.map((b, i) => (
        <div key={i} className={`${b.className} filter-btn`}>
          <FilterButton text={b.text} value={b.value} onClick={onClick} selectedOptions={selectedOptions} />
        </div>
      ))}
      <div className='p-3 actions'>
        <GraviButton size='small' style={{ width: '100%' }} buttonText='Clear' theme3 onClick={() => onClear()} />
      </div>
    </div>
  )
}

const FilterButton = ({ text, value, onClick, selectedOptions }) => (
  <Button
    size='small'
    className={`${selectedOptions && selectedOptions.includes(value) ? 'selected' : ''}`}
    onClick={() => onClick(value)}
  >
    {text}
  </Button>
)
